<template>
  <button class="add-character-card" type="button" @click="emit('create')">
    <span class="add-icon-box">
      <el-icon :size="24"><Plus /></el-icon>
    </span>
    <span class="add-title">创建新角色</span>
    <span class="add-subtitle">设计你的绘本主角</span>
  </button>
</template>

<script setup lang="ts">
  import { Plus } from '@element-plus/icons-vue';

  const emit = defineEmits<{
    create: [];
  }>();
</script>

<style scoped>
  .add-character-card {
    width: 236px;
    height: 280px;
    box-sizing: border-box;
    border-radius: 16px;
    background: #fff;
  }

  .add-character-card {
    display: flex;
    flex-direction: column;
    align-items: center;
    border: 2px dashed rgba(96, 51, 225, 0.3);
    padding-top: 82px;
    cursor: pointer;
    color: inherit;
    font: inherit;
    transition:
      border-color 0.16s ease,
      box-shadow 0.16s ease,
      transform 0.16s ease;
  }

  .add-character-card:hover,
  .add-character-card:focus-visible {
    border-color: rgba(96, 51, 225, 0.62);
    box-shadow: 0 4px 16px rgba(96, 51, 225, 0.08);
    outline: none;
    transform: translateY(-1px);
  }

  .add-icon-box {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 48px;
    height: 48px;
    border-radius: 14px;
    background: rgba(237, 232, 255, 0.6);
    color: #6033e1;
  }

  .add-title {
    margin-top: 25px;
    color: #000;
    font-family: 'Source Han Sans CN VF', 'Noto Sans SC', 'Microsoft YaHei', sans-serif;
    font-size: 16px;
    font-weight: 500;
    line-height: 18px;
  }

  .add-subtitle {
    margin-top: 11px;
    color: rgba(51, 51, 51, 0.5);
    font-family: 'Noto Sans SC', 'Source Han Sans CN VF', 'Microsoft YaHei', sans-serif;
    font-size: 13px;
    font-weight: 500;
    line-height: 14px;
  }

  @media (max-width: 900px) {
    .add-character-card {
      width: 100%;
    }
  }

  @media (max-width: 767px) {
    .add-character-card {
      display: none;
    }
  }
</style>
